import { Button } from 'foundations-components/transitional/components/Button';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { useCallback, useState } from 'react';
import { useResetCardSectionSettings } from '../../api/useResetCardSectionSettings';
import { showFailureAlert, showSuccessAlert } from '../../utils/successFailureAlerts';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useResetDraftSettings } from '../../settings/store/slice/sectionSettingsActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConfirmResetModal = ({
  onClose
}) => {
  const resetDraftSettings = useResetDraftSettings();
  const {
    resetCardSectionSettings,
    loading: isSaveInProgress
  } = useResetCardSectionSettings();
  const handleSave = useCallback(() => {
    resetCardSectionSettings().then(() => {
      // Reset any changes user made to draft settings
      resetDraftSettings();
      showSuccessAlert();
      onClose();
    }).catch(() => {
      showFailureAlert();
    });
  }, [resetCardSectionSettings, resetDraftSettings, onClose]);
  return /*#__PURE__*/_jsx(ConfirmModal, {
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "crmObjectBoardCard.settings.reset.confirm"
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "crmObjectBoardCard.settings.reset.cancel"
    }),
    confirmUse: "danger",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "crmObjectBoardCard.settings.reset.description"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "crmObjectBoardCard.settings.reset.title"
    }),
    size: "auto",
    use: "danger",
    onConfirm: handleSave,
    confirmButtonProps: {
      'data-test-id': 'board-card-reset-confirm'
    },
    onReject: onClose,
    disableConfirm: isSaveInProgress
  });
};
export const CardSectionSettingsResetButton = () => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const handleOpenModal = useCallback(() => setShowConfirmationModal(true), []);
  const handleCloseModal = useCallback(() => setShowConfirmationModal(false), []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: handleOpenModal,
      "data-test-id": "board-card-reset-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmObjectBoardCard.settings.reset.title"
      })
    }), showConfirmationModal && /*#__PURE__*/_jsx(ConfirmResetModal, {
      onClose: handleCloseModal
    })]
  });
};